import React from 'react';
import { FiPlus, FiX } from 'react-icons/fi';

import { Container, Row, Radio, Letter, TextInput, RemoveButton, AddButton, Hint } from './styles';

const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

interface OptionsEditorProps {
  options: string[];
  correctIndex: number;
  onChangeOption: (index: number, value: string) => void;
  onChangeCorrect: (index: number) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  /** Nome do grupo de radios (precisa ser único na página). */
  name: string;
}

/**
 * Editor de alternativas de múltipla escolha (exercício e quiz). A resposta
 * correta é marcada pelo radio à esquerda de cada alternativa.
 */
const OptionsEditor: React.FC<OptionsEditorProps> = ({
  options,
  correctIndex,
  onChangeOption,
  onChangeCorrect,
  onAdd,
  onRemove,
  name,
}) => (
  <Container>
    <Hint>Marque a bolinha da alternativa correta.</Hint>

    {options.map((option, index) => (
      <Row key={index}>
        <Radio
          type="radio"
          name={name}
          checked={correctIndex === index}
          onChange={() => onChangeCorrect(index)}
          aria-label={`Marcar alternativa ${LETTERS[index]} como correta`}
        />
        <Letter aria-hidden>{LETTERS[index]})</Letter>
        <TextInput
          type="text"
          value={option}
          onChange={(event) => onChangeOption(index, event.target.value)}
          placeholder={`Texto da alternativa ${LETTERS[index]}`}
          aria-label={`Alternativa ${LETTERS[index]}`}
        />
        {options.length > 2 && (
          <RemoveButton
            type="button"
            onClick={() => onRemove(index)}
            aria-label={`Remover alternativa ${LETTERS[index]}`}
            title="Remover alternativa"
          >
            <FiX size={14} />
          </RemoveButton>
        )}
      </Row>
    ))}

    {options.length < LETTERS.length && (
      <AddButton type="button" onClick={onAdd}>
        <FiPlus size={14} />
        Adicionar alternativa ({LETTERS[options.length]})
      </AddButton>
    )}
  </Container>
);

export default OptionsEditor;
